
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import { translate } from 'react-i18next'
import {FACTOR_EFFECTS} from '../../../constants'
import Slider from '../slider2/Slider'

const styles = {
  sliderContainer: {marginTop: 60}
}

class ComparingImportanceSlider extends Component {

  static sliderMarks = FACTOR_EFFECTS.text.reduce((accumulator, text, index) => {
    accumulator[index] = text
    return accumulator
  }, {})

  constructor(props) {
    super(props)
    this.state = {
      sliderIndex: this.getSliderIndex(props.weight)
    }
  }

  getSliderIndex = (weight) => {
    const index = FACTOR_EFFECTS.weights.indexOf(weight)
    return index === -1 ? null : index
  }

  handleChange = (sliderIndex) => {
    this.props.onChange(FACTOR_EFFECTS.weights[sliderIndex])
  }


  render() {

    const {t} = this.props

    Object.keys(ComparingImportanceSlider.sliderMarks).forEach(function(key) {
      ComparingImportanceSlider.sliderMarks[key] = t(ComparingImportanceSlider.sliderMarks[key])
    })


    return (
      <Grid container justify="center" style={styles.sliderContainer}>
        <Grid item xs={8} sm={10}>
          <Slider
            disabled={this.props.disabled}
            onChange={this.handleChange}
            value={this.state.sliderIndex}
            sliderTextType={"importanceSlider"}
          />
        </Grid>
      </Grid>
    )
  }
}

ComparingImportanceSlider.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  weight: PropTypes.number.isRequired
}

export default translate()(ComparingImportanceSlider)


// WEBPACK FOOTER //
// ./src/components/counseling-session/comparing-importance/ComparingImportanceSlider.js